import { render } from "./DataDocument.vue?vue&type=template&id=508b1e88&scoped=true"
import script from "./DataDocument.vue?vue&type=script&lang=js"
export * from "./DataDocument.vue?vue&type=script&lang=js"

import "./DataDocument.vue?vue&type=style&index=0&id=508b1e88&lang=css"
import "./DataDocument.vue?vue&type=style&index=1&id=508b1e88&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508b1e88"]])

export default __exports__